import $ from "jquery";

$(function() {
    $(".bl-reflist").each(function() {
        const $bl = $(this);
        initReferenzList($bl);
    });
});

function initReferenzList($bl) {
    const $ctrfilter = $bl.find(".ctrfilter");
    const $ctritems = $bl.find(".ctritems");
	$ctrfilter.on("click", "li", function() {
        const $li = $(this);
        $li.toggleClass("active");
        $ctritems.fadeOut(200, function() {
            updateItemVisibility($bl);
            $ctritems.fadeIn(200);
        });
	});
    
    updateItemLR($bl);

    //Hash Links (Seite Dienstleistungen)
    //Filter zur Zeit deaktiviert.
    const hash = window.location.hash;
    if(hash) {
        const filter = hash.substring(1);
        $bl.find(".ctrfilter li:contains('"+filter+"')").trigger("click");
    }
}

function updateItemVisibility($bl) {
    const filters = [];
    $bl.find(".ctrfilter li.active").each(function() {
        const $li = $(this);
        const filter = $li.data("phaseid");
        filters.push(filter);
    });

    if(filters.length == 0) {
        //No filter active => show all
        $bl.find(".item").removeClass("filter-hidden");
        return;
    }

    $bl.find(".item").addClass("filter-hidden");
    for(const filter of filters) {
        $bl.find(".item").each(function() {
            const $item = $(this);
            if($item.data("tags").includes(filter)) {
                $item.removeClass("filter-hidden");
            }
        });
    }

    updateItemLR($bl);
}

function updateItemLR($bl) {
    let isLeft = true;
    $bl.find(".item").each(function() {
        const $item = $(this);
        if($item.hasClass("filter-hidden")) {
            return;
        }
        $item.toggleClass("lrpos-l", isLeft);
        $item.toggleClass("lrpos-r", !isLeft);
        isLeft = !isLeft;
    });
}
